import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const toneFill = {
    brand: 'bg-brand',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
    muted: 'bg-muted-foreground/70'
};
export const SpecraProgress = /*#__PURE__*/ React.forwardRef(({ className, size = 'default', tone = 'brand', value = 0, ...props }, ref)=>{
    const pct = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 0));
    return /*#__PURE__*/ _jsx("div", {
        ...props,
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": pct,
        className: cn('w-full overflow-hidden rounded-full bg-border', size === 'thin' ? 'h-[var(--component-progress-track-height-thin)]' : 'h-[var(--component-progress-track-height)]', className),
        ref: ref,
        role: "progressbar",
        children: /*#__PURE__*/ _jsx("div", {
            className: cn('h-full rounded-full transition-[width]', toneFill[tone]),
            style: {
                width: `${pct}%`
            }
        })
    });
});
SpecraProgress.displayName = 'SpecraProgress';
